import {
} from "./actions";
import {
} from "../redux-root/actions";

const initialState = {
  loading: false
};

export function appReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    default:
      return state;
  }
}
